export default {
  'Header.logout': 'Выйти',
  'Header.analyzedText': 'Отзывов проанализировано',
}
